import React from 'react';
import { Link } from 'react-router-dom';

interface BlogBannerProps {
  title: string;
  subtitle?: string;
}

// Note: Using a freely available grocery-themed background image from Unsplash
// Photo from Unsplash (free to use under Unsplash license)
const GROCERY_BACKGROUND_IMAGE = 'https://images.unsplash.com/photo-1542838132-92c53300491e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80';

const BlogBanner: React.FC<BlogBannerProps> = ({ title, subtitle }) => {
  return (
    <div 
      className="blog-banner"
      style={{
        position: 'relative',
        width: '100%',
        height: '240px',
        backgroundImage: `url(${GROCERY_BACKGROUND_IMAGE})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '50px', // Increased white space between header and banner
        marginBottom: '0',
        borderRadius: '4px', // Add subtle rounded corners
        overflow: 'hidden',
      }}
    >
      {/* Dark overlay for better text readability */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1,
      }} />
      
      {/* Text content */}
      <div style={{ zIndex: 2, textAlign: 'center', padding: '0 20px' }}>
        <h1 style={{ 
          color: 'white', 
          fontSize: '42px', 
          fontWeight: 'bold',
          margin: '0 0 15px 0',
          fontFamily: 'inherit',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ 
            color: 'white', 
            fontSize: '18px',
            margin: 0,
            maxWidth: '800px',
            fontFamily: 'inherit',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
          }}>
            {subtitle}
          </p>
        )}
      </div>
      
      {/* No purple accent bar - removed as requested */}
      
      {/* Breadcrumb navigation */}
      <div style={{ 
        position: 'absolute', 
        bottom: '15px', 
        left: 0,
        width: '100%',
        textAlign: 'center',
        color: 'rgba(255, 255, 255, 0.9)',
        fontSize: '14px',
        fontFamily: 'inherit',
        zIndex: 2,
        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
      }}>
        <Link to="/" style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none' }}>Home</Link>
        <span style={{ margin: '0 10px' }}>→</span>
        <span>Blog</span>
      </div>
    </div>
  );
};

export default BlogBanner;
